<template>
	<v-list-item link :to="{ name: view }" :exact="exact">
		<v-list-item-action v-if="icon">
			<v-icon small>{{ icon }}</v-icon>
		</v-list-item-action>
		<v-list-item-content>
			<v-list-item-title>{{ title }}</v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
export default {
	props: {
		icon: String,
		title: String,
		view: String,
		exact: {
			type: Boolean,
			default: false,
		},
	},
}
</script>
